import React from 'react';
import '../styles/AboutUs.css';

const AboutUs = () => {
  return (
    <section id="about" className="about-us">
      <div className="about-container">
        <div className="about-content">
          <h2 className="about-title">About Taxi 24hrs</h2>
          <p className="about-text">
            Welcome to Taxi 24hrs, your trusted partner for reliable and professional transportation services. 
            With over a decade of experience in the taxi industry, we've been committed to providing safe, 
            comfortable, and affordable rides to thousands of satisfied customers.
          </p>
          <div className="about-features">
            <div className="about-feature-item">
              <span className="about-feature-icon">✅</span>
              <h4>24/7 Availability</h4>
              <p>Always available when you need us, day or night</p>
            </div>
            <div className="about-feature-item">
              <span className="about-feature-icon">✅</span>
              <h4>Professional Drivers</h4>
              <p>Fully trained and verified drivers with excellent track records</p>
            </div>
            <div className="about-feature-item">
              <span className="about-feature-icon">✅</span>
              <h4>Modern Vehicles</h4>
              <p>Latest fleet of well-maintained vehicles for your comfort</p>
            </div>
            <div className="about-feature-item">
              <span className="about-feature-icon">✅</span>
              <h4>Customer Satisfaction</h4>
              <p>Dedicated to delivering exceptional service to every customer</p>
            </div>
          </div>
        </div>
        <div className="about-image">
          <img src="/images/about.png" alt="Taxi 24hrs about service" className="about-image-content" />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
